import { useContext } from 'react';
import { DashboardDataContext } from '../context/DashboardDataContext';
export type { Organization, Site, Unit } from '../context/DashboardDataContext';

export function useDashboardData() {
  const context = useContext(DashboardDataContext);
  if (!context) {
    throw new Error('useDashboardData must be used within a DashboardDataProvider');
  }
  return context;
}
